import Component from 'vue-class-component';
import { Prop, Watch , Mixins} from 'vue-property-decorator';
import {numeric, required , maxLength} from 'vuelidate/lib/validators';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import KEYS from '@/values/keys';
import { SECTION_TYPES } from '@/content/values/sections';
import Tools from '@/providers/tools';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';
import EdMaterialViewer from '@/courses/components/ed-material-viewer/ed-material-viewer.vue';
import EdCreateCMaterialSections from './ed-create-c-material-sections/ed-create-c-material-sections.vue';
import { COURSE_MATERIAL_KEYS, MULTIMEDIA_FILES_TYPES_EXT } from '@/courses/values/courses.values'
import EdPreviewFilePages from '@/courses/components/ed-preview-file-pages/ed-preview-file-pages.vue'
import { SectionsProvider } from '@/content/providers/sections.provider';
import SectionSchoolCalendarMixin from '@/sections/mixins/section-school-calendar.mixin';
import EdSelectComponentCourse from '@/course-templates/components/ed-select-component-course/ed-select-component-course.component.vue';
import {IParamsCreateComponent} from '@/courses/interfaces/params-create-component.interface';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import EdPdfRotatePages from '@/courses/components/ed-pdf-rotate-pages/ed-pdf-rotate-pages.vue';

@Component({
  name: 'ed-create-course-material-object',
  components: {
    EdFileViewer,
    EdCreateCMaterialSections,
    EdMaterialViewer,
    EdPreviewFilePages,
    EdSelectComponentCourse,
    EdPdfRotatePages,
    EdSelectTag: () => import(/* EdSelectTag */'@/courses/components/ed-select-tag/ed-select-tag.component.vue'),
  }
})
export default class EdCreateCourseMaterialObject extends Mixins(SectionSchoolCalendarMixin, CourseToolsMixin) {

  /* Arguments */
  @Prop() readonly onChanged: Function;
  @Prop() readonly onSave: Function;
  @Prop() readonly currentData: any;
  @Prop() readonly product: any;
  @Prop() readonly section: any;

  /* Data */
  public form: any = {};
  public currentMaterial: any = null;
  public viewerComponent: any = null;
  public currentSection: any = null;
  public currentTime: any = Date.now();
  public currentEpubTocs : any = [];
  public tocStartSelected: any = null;
  public tocEndSelected: any = null;
  public retrievingEpubInfo: boolean = false;
  public isShowViewer: boolean = false;
  public viewerSectionMaterial: any = null;
  public checkTocEndInit : boolean = true;
  public componentKey : number = 0;
  public picked: string = 'CONTINUE';
  public pickedValue: boolean = false;
  public isSaving: boolean = false;
  public isInvalidDates: boolean = false;
  public isHomework: boolean = false;
  public choosePages: boolean = false;
  public tags: Array<string> = ['TEST', 'CLASSWORK', 'HOMEWORK'];
  public tagSelected: string = '';
  public showSaveButton: boolean = false;
  private rotationModeEnable: boolean = false;
  public canShowRotation: boolean = false;
  private lastUrl : string = '';
  

  /* Method */
  public init(name = '' , start = '', end = null, dueDate = '', lastDate = ''): void {
    let fields = [
      EdInputModel('name', name, {required , maxLength: maxLength(70)}),
      EdInputModel('start', start, {required , numeric}),
      EdInputModel('end', end, { numeric, required }),
      EdInputModel('dueDate', dueDate, {}),
      EdInputModel('lastDate', lastDate, {}),
      EdInputModel('homeworkPoints', 100, {}, true),
      EdInputModel('homeworkWeight', 1, {}, true)
    ];
    this.form = EdFormModel(fields);
  }

  public closeModal(): void {
    this.$EdModal.closeModal();
  }

  public rotateModal() : void {
    this.rotationModeEnable = true;
  }

  public async onRotatePages(rotatePageList:{page:number,rotateDegrees:number}[]) {
    if( (rotatePageList || []).length <= 0 ) {
      this.rotationModeEnable = false;
    } else if(this.hasBeenHomeworkResolvedByAnyStudent) {
      this.$EdModal.createConfirmationModal(
        {
          body: this.$i18n.t('courses.objects.confirmRotateEdit'),
          action: async () => {
            this.saveRotatePages(rotatePageList);
          },
          secondAction: () => {
            this.rotationModeEnable = false;
          }
        }
      );
    } else {
      this.saveRotatePages(rotatePageList);
    }
  }

  async saveRotatePages(rotatePageList:{page:number,rotateDegrees:number}[]) {
    const sectionId = this.section.sectionId;
    const courseId = this.section.courseId;
    const newHash = await this.$Courses.Store.rotateContentAssetA({courseId, sectionId, rotatePageList});
    if(newHash) {
      this.getPdfUrl();
    } else {
      this.rotationModeEnable = false;
    }
  }

  async getPdfUrl() {
    let fileData = { sectionId: this.section.sectionId , materialId: null ,
      courseId: this.section.courseId , classId: this.section.classId};
    
    this.deleteFromStorage(fileData.sectionId , null);

    let isProcessing = this.checkStorage(fileData.sectionId , null);
    if(isProcessing) {
      let intervalId : any = setInterval((data) => {
        this.waitForReadyFileInfo(intervalId , data).then(
          (status) => {
            if(status != 206) {
              const url = this.getPdfUrlForVisualRotation();
              if(url && url !== this.lastUrl) {
                this.lastUrl = url;
                this.rotationModeEnable = false;
                this.closeModal();
              } else {
                this.getPdfUrl();
              }
            } else {
              this.getPdfUrl();
            }
          }
        );
      }, 15000 , fileData);
    }
  }

  public getPdfUrlForVisualRotation() : string {
    
    let pdfurl = null;

    let sectionToEdit = (this.sectionUpdated && this.sectionUpdated.id == this.section.id) ? this.sectionUpdated : this.section;
    
    if(sectionToEdit) {
      if(sectionToEdit.assetsInfo && sectionToEdit.assetsInfo[0].url) {
        if(sectionToEdit.assetsInfo[0].pdfUrl) {
          pdfurl = sectionToEdit.assetsInfo[0].pdfUrl;
        }
      } else if(sectionToEdit.sectionMaterial?.displayType === COURSE_MATERIAL_KEYS.SPLICE && 
        sectionToEdit.sectionMaterial.splicedUrl) {
        pdfurl = sectionToEdit.sectionMaterial.splicedUrl;
      } else if(sectionToEdit.sectionMaterial?.displayType === COURSE_MATERIAL_KEYS.CONTINUE &&
        sectionToEdit.sectionMaterial?.materialAssetInfo?.pdfUrl) {
        pdfurl = sectionToEdit.sectionMaterial?.materialAssetInfo?.pdfUrl;
      }
    }

    return pdfurl;
  }

  disableRotation() {
    if(this.currentMaterial?.relatedContentId == this.section?.sectionMaterial?.materialId && this.params.edition 
        && this.currentMaterial?.data?.pdfUrl) {
      this.canShowRotation = true;
    } else {
      this.canShowRotation = false;
    }
  }

  getDataToSave() {
    if(this.currentMaterial) {
      let data: any = {
        name: this.hasName ? this.form.name.value : '',
        startLabel: (this.currentMaterial.data.subtype == KEYS.FILES_TYPE.EPUB) && (this.tocStartSelected != null) ? this.tocStartSelected.value : '',
        endLabel: (this.currentMaterial.data.subtype == KEYS.FILES_TYPE.EPUB) && (this.tocEndSelected != null) ? this.tocEndSelected.value : '',
        material: this.currentMaterial,
        displayType: this.picked,
        homework: this.isMultimediaFile(this.currentMaterial.data.mimeType) ? false : this.isHomework,
        homeworkPoints: this.form.homeworkPoints.value,
        homeworkWeight: this.form.homeworkWeight.value,
        dueDate: this.form.dueDate.value,
        lastDate: this.form.lastDate.value,
        labelSections: this.tagSelected,
        component: this.componentSelected
      }
      if(this.currentMaterial.data.subtype == KEYS.FILES_TYPE.EPUB) {
        data.end = this.tocEndSelected != null ? this.tocEndSelected.key : '';
        data.start = this.tocEndSelected != null ? this.tocStartSelected.key : '';
      } else {
        data.start = this.form.start.value;
        data.end = this.form.end.value ? this.form.end.value : null;
      }
      data.valid = (!this.isDataInvalid && !this.isInvalidDates);
      return data;
    } else {
      return {
        valid: false
      };
    }
  }

  public next() {
    let mimeType = this.currentMaterial.data.mimeType;
    if( this.isMultimediaFile(mimeType) ) {
      this.picked = COURSE_MATERIAL_KEYS.CONTINUE;
      this.save();
    } else {
      this.choosePages = true;
      this.closeViewer();
    }
  }

  public save(): void {
    let data = this.getDataToSave();
    this.$emit('onSave', data);
  }

  public change() {
    let data = this.getDataToSave();
    this.disableRotation();
    this.$emit('onChanged', data);
  }

  public onView(material: any): void {
    if(this.currentSection) {
      if(material.relatedContentId == this.currentSection.id) {
        this.closeViewer();
        this.currentSection = null;
        return;
      }
    }

    this.isShowViewer = true;
    let section = {
      id: material.relatedContentId,
      type: SECTION_TYPES.LESSON_MATERIAL.code,
      sectionMaterial: {
        startSection: material.data.subtype == KEYS.FILES_TYPE.EPUB ? 'all': '1'
      }
    };
    this.currentSection = null;
    this.viewerComponent = null;
    this.viewerSectionMaterial = null;
    this.$nextTick(() => {
      this.currentSection = section;
        this.viewerComponent = this.setCourseMaterialViewer(material);
      this.viewerSectionMaterial = material;
    });
  }

  public onAdd(material: any): void {
    let mimeType = material.data.mimeType;
    if( this.isMultimediaFile(mimeType) ) {
      this.showSaveButton = true;
    } else {
      this.showSaveButton = false;
    }
    if (this.params.edition && this.params.currentMaterial.relatedContentId == material.relatedContentId) {
      this.setEditionMode();
    } else {
      this.currentMaterial = material;
      if(material.data.subtype == KEYS.FILES_TYPE.EPUB){
        this.getEpubInfo(material.data.url);
      }    
      this.form.set('start');
      this.form.set('end');
    }
    if(this.components && this.currentMaterial?.component) {
      this.componentSelected = this.components.find(c => c.id == this.currentMaterial.component.id);
    }
    this.change();
  }

  public onRemove(): void {
    this.currentMaterial = null;
    this.showSaveButton = false;
    this.change();
  }

  public updateOnblur(): void {
    setTimeout(() => {
      this.currentTime = Date.now();
    }, 100)
  }

  public selectStartAndEndToc(): void{
    let firstToc = this.currentEpubTocs.find((toc: any) => toc.key == this.params.start);
    if(firstToc) {
      this.tocStartSelected = firstToc;
    }
  }

  public async getEpubInfo(urlEpub: any): Promise<any>{
    this.retrievingEpubInfo = true;
    this.currentEpubTocs = [];
    this.tocStartSelected = null;
    this.tocEndSelected = null;
    let resultPromiseEpub = await Tools.getChapterFromEbup(urlEpub);
    this.currentEpubTocs = resultPromiseEpub.toc.map((toc: any) => {
      return { key: toc.href, value: toc.label }
    });
    this.retrievingEpubInfo = false;
    this.selectStartAndEndToc();

  }

  public selectChapterStart(option: any): void{
    this.tocStartSelected = option;
  }

  public selectChapterEnd(option: any): void{
    this.tocEndSelected = option;
  }

  public onRadioChanged() {
    if(this.picked === COURSE_MATERIAL_KEYS.SPLICE) {
      this.form.setValidator('start', 'required', required);
      this.pickedValue = true;
    } else {
      this.form.removeValidator('start', 'required');
      this.pickedValue = false;
    }
    setTimeout(() => { this.change(); }, 100);
  }

  public setSaving(value: boolean) {
    this.isSaving = value;
  }

  public validatePagesSelected() {
    let numberOfPages = this.currentMaterial ? this.currentMaterial.data.numberOfPages : null;
    let star = this.form.start.value;
    let end = this.form.end.value;
    if(numberOfPages) {
      if(this.picked === COURSE_MATERIAL_KEYS.SPLICE) {
        this.isInvalidDates = star > numberOfPages || end > numberOfPages;
      } else {
        this.isInvalidDates = star > numberOfPages;
      }
    }
    this.change();
  }

  public goBack() {
    this.choosePages = false;
  }

  public saveFile(data: any) {
    this.form.start.value = data.start;
    this.form.end.value = data.end;
    this.form.dueDate.value = data.homework ? data.dueDate : '';
    this.form.lastDate.value = data.homework ? data.lastDate : '';
    this.picked = data.picked,
    this.isHomework = data.homework;
    this.form.homeworkPoints.value = data.homeworkPoints;
    this.form.homeworkWeight.value = data.homeworkWeight;
    this.choosePages = false;
    this.save();    
  }

  /* Computed */
  get materials() {
      return this.product.materials;
  }

  get hasTitle() {
    return this.params.hasTitle;
  }

  get hasButtons() {
    return this.params.hasButtons;
  }

  get hasName() {
    return this.params.hasName;
  }

  get title() {
    return this.params.edition ? this.$i18n.t('courses.courseMaterialObject.editTitle') : this.$i18n.t('courses.courseMaterialObject.createTitle');
  }

  get modalStyle() : any{
    return this.isShowViewer ? { width: '90vw'} : { minWidth: '600px', maxWidth: '790px'}
  }

  get currentEpubTocsEnd() : any {
    if(this.tocStartSelected == null){
      return this.currentEpubTocs;
    }
    let indexStartToc : number = this.currentEpubTocs.findIndex((toc: any) => toc.key == this.tocStartSelected.key)
    if(indexStartToc == -1){
      return this.currentEpubTocs;
    }else{
      return this.currentEpubTocs.filter((toc: any, index: number) => index > indexStartToc);
    }
  }

  get showEduacComponent(): boolean {
    return this.params.hasTagSelector && this.currentMaterial;
  }

  get isFormValid(): boolean {
    return this.form.name.valid && this.currentMaterial;
  }

  get isDataInvalid(): boolean {
    let nameValid = this.hasName ? this.form.name.valid : true;
    if(!this.pickedValue) {
      if(nameValid && this.currentMaterial) {
        return this.form.start.value === '' ? false : !this.form.start.valid;
      } else {
        return true;
      }
    } else {
      return !this.form.valid
    } 
  }

  get onlyDisplayType(): string {
    return this.params.onlyDisplayType;
  }

  get invalidDatesMsg(): string {
    let msg = '';
    if(this.isInvalidDates && this.currentMaterial) {
      let numOfPages = this.currentMaterial.data.numberOfPages;
      msg = String(this.$i18n.t('courses.materials.errorDatesCMO'));
      msg = msg.replace('{numOfPages}', String(numOfPages));
    }
    return msg;
  }

  get paramsToPreviewPages(): any {
    let params = { 
      product: this.product,
      minDate: this.params.minDate 
    };
    if(this.params.edition) {
      let isTheSame = this.currentMaterial.relatedContentId === this.params.currentMaterial.relatedContentId;
      return isTheSame ? this.params : params
    } else
      return params
  }

  get urlDisplay(): string {
    if(this.currentMaterial) {
      if(this.currentMaterial.data.pdfUrl) 
        return this.currentMaterial.data.pdfUrl;
      else 
        return this.currentMaterial.data.subtype === KEYS.FILES_TYPE.PDF ? this.currentMaterial.data.contentFileUrl : null;         
    } else
      return null;
  }

  get showNextBtnText() {
    return this.showSaveButton ? this.$i18n.t('common.save') : this.$i18n.t('common.next');
  }

  get isUrlLoaded() {
    const url = this.getPdfUrlForVisualRotation();
    if(url) {
      this.lastUrl = url;
      return true;
    }
    return false;
  }

  get sectionUpdated() {
    return this.$store.state.CourseStore.sectionToEdit;
  }

  get hasBeenHomeworkResolvedByAnyStudent() {
    return this.section.hasBeenResolvedByAnyStudent ? this.section.hasBeenResolvedByAnyStudent : false;
  }

  get components() {
    return this.product.eduacComponents;
  }

  get componentSelected() : IParamsCreateComponent {
    return this.$store.state.CourseStore.eduacComponentSelected;
  }

  
  set componentSelected(newValue : IParamsCreateComponent) {
    this.$Courses.Store.setEduacComponentSelected(newValue);
  }

  /* Watches */
  @Watch('tocStartSelected')
  public checkTocStartChange(): void {
    let keyToCompare : any = '';
    if(this.checkTocEndInit){
      keyToCompare = this.params.end;
      this.checkTocEndInit = false;
    }else{
      keyToCompare = this.tocEndSelected == null ? null : this.tocEndSelected.key;
    }
    let lastToc = this.currentEpubTocsEnd.find((toc: any) => toc.key == keyToCompare);
    this.tocEndSelected = lastToc ? lastToc : null;
    if(lastToc) {
      this.tocEndSelected = lastToc;
    }
    this.componentKey++;
  }

  @Watch('form', { deep: true, immediate: false })
  formChanged() {
    this.validatePagesSelected();
  }

  @Watch('currentData')
   setData() { 
     this.form.set('start' , this.currentData.start);
    this.form.set('end' , this.currentData.end);
    this.form.setValid('start' , true);
    this.form.setValid('end' , true);
    this.picked = this.currentData.picked;
    this.change();
  } 

  setEditionMode() {
    let { start, end } = this.params;

    this.currentMaterial = this.params.currentMaterial;
    this.isHomework = this.params.homework;
    this.picked = this.params.displayType;
    this.tagSelected = this.params.labelSections;

    this.init(
      this.params.name,
      String(start),
      isNaN(Number(end)) ? '' : end,
      this.params.dueDate, 
      this.params.lastDate
    );
    this.form.fieldsName.forEach((name: string) => {
      this.form.setValid(name , true);
    });    
    if((this.params.currentMaterial != null) && ('data' in this.params.currentMaterial) && (this.params.currentMaterial.data.subtype == KEYS.FILES_TYPE.EPUB)) {
      this.getEpubInfo(this.params.currentMaterial.data.url);
    }
    this.change();
  }

  closeViewer() {
    this.isShowViewer = false;
    this.currentSection = null;
  }

  /* Hooks */
  created() {
    if(this.params.edition) {
      if(this.params?.currentMaterial?.data?.pdfUrl) {
        this.canShowRotation = true;
      } 
       this.setEditionMode();
      if(this.currentMaterial?.component && this.components) {
        this.componentSelected = this.components.find(c => c.id == this.currentMaterial.component.id);
      }
    } else {
      this.canShowRotation = false;
      this.init();
      if(this.params.onlyDisplayType) {
        this.picked = this.params.onlyDisplayType;
      }
    }
    this.onRadioChanged();

    this.$Courses.Store.resetSectionToEditM();
  }

}